import axios from 'axios'
import {
  FETCHING_IP_INFO,
  RECEIVED_IP_INFO,
  ERROR_FETCHING_IP_INFO
} from './constants/location'

const ONE_DAY_IN_MILLISECONDS = 86400000

// eslint-disable-next-line import/prefer-default-export
export const getOrFetchUserIPInfo = () => async (dispatch) => {
  dispatch({ type: FETCHING_IP_INFO })

  // check localStorage for non-stale ipInfo
  const ipInfo = getLocalStorageIPInfo()

  if (ipInfo) {
    dispatch({ type: RECEIVED_IP_INFO, data: ipInfo })
  } else {
    const response = await fetchUserIPInfo()
    if (response) {
      dispatch({ type: RECEIVED_IP_INFO, data: response })
      window.localStorage.setItem('ipInfo', JSON.stringify(response))
    } else {
      dispatch({ type: ERROR_FETCHING_IP_INFO })
    }
  }
}

/**
 * @description fetches ipInfo from ipinfo.io api
 * @returns ipInfo object with timestamp in ms
 */
const fetchUserIPInfo = async () =>
  axios
    .get(
      `https://ipinfo.io/json?token=${process.env.NEXT_PUBLIC_IP_INFO_TOKEN}`
    )
    .then(async (res) => {
      if (res.data) {
        const { country: countryCode, loc, city, region } = res.data
        if (loc) {
          const lat = parseFloat(loc.split(',')[0])
          const lng = parseFloat(loc.split(',')[1])
          const dataObj = {
            city,
            region,
            countryCode,
            position: {
              lat,
              lng
            },
            json: res.data,
            timestamp: Date.now()
          }
          return dataObj
        }
        return null
      }
      return null
    })
    .catch(() => null)

/**
 * @description get ipInfo from localStorage and check if fetched within last 24 hrs
 * @returns ipInfo if present and not stale (within 24 hrs), else null
 */
const getLocalStorageIPInfo = () => {
  const temp = window.localStorage.getItem('ipInfo')
  if (!temp) return null

  try {
    const ipInfo = JSON.parse(temp)
    if (ipInfo && ipInfo?.timestamp > Date.now() - ONE_DAY_IN_MILLISECONDS) {
      return ipInfo
    }
    return null
  } catch (err) {
    return null
  }
}
